import { motion } from 'framer-motion';
import { Stethoscope, BarChart3, Beaker, ScrollText, Users } from 'lucide-react';

const reviewers = [
  {
    icon: Stethoscope,
    name: 'The Clinician',
    title: 'Senior attending',
    headline: '"What is the absolute risk reduction in your high-grade subgroup?"',
    tag: 'CLINICAL.RELEVANCE',
  },
  {
    icon: BarChart3,
    name: 'The Statistician',
    title: 'Biostatistics chair',
    headline: '"Multiple testing correction is not stated; α inflated to ~0.17."',
    tag: 'STATS.METHODOLOGY',
  },
  {
    icon: Beaker,
    name: 'The Methodologist',
    title: 'Cochrane editor',
    headline: '"Selection bias is plausible; sensitivity analysis recommended."',
    tag: 'STUDY.DESIGN',
  },
  {
    icon: ScrollText,
    name: 'The Journal',
    title: 'NEJM associate',
    headline: '"Abstract overstates novelty relative to van Santvoort 2010."',
    tag: 'EDITORIAL.RIGOR',
  },
  {
    icon: Users,
    name: 'The Committee',
    title: 'Defense chair',
    headline: '"Where in your thesis do you address the contradicting Bakker 2012 result?"',
    tag: 'DEFENSE.READINESS',
  },
];

export default function ReviewerGrid() {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-3">
      {reviewers.map((r, i) => (
        <motion.div
          key={r.name}
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ delay: i * 0.08, duration: 0.5 }}
          viewport={{ once: true, margin: '-50px' }}
          data-testid={`reviewer-card-${i}`}
          className="group relative rounded-none border border-slate-900/8 bg-white hover:bg-slate-50 transition-colors p-4 flex flex-col">
          <div className="flex items-center justify-between mb-3">
            <r.icon className="h-5 w-5 text-slate-700" strokeWidth={1.5} />
            <span className="text-[8.5px] font-mono uppercase tracking-[0.15em] text-slate-400 group-hover:text-[hsl(212,90%,55%)] transition-colors">
              {r.tag}
            </span>
          </div>
          <h4 className="font-serif text-base text-slate-900 leading-tight mb-0.5">
            {r.name}
          </h4>
          <p className="text-[10.5px] uppercase tracking-wider text-slate-500 mb-3 font-mono">
            {r.title}
          </p>
          <p className="text-[12.5px] text-slate-700 italic leading-relaxed mt-auto border-l-2 border-slate-200 pl-2">
            {r.headline}
          </p>
        </motion.div>
      ))}
    </div>
  );
}
